// modules
const company = "company"
const saloon = "saloon"
const web = "web"
const marketing = "marketing"
const customer = "customer"
const calendar = "calendar"
const financeReport = "financeReport"
const program = "program"

export const dashboardPagesMenu = {
	dashboard: {
		id: "dashboard",
		text: "main",
		path: "/",
		icon: "Dashboard",
		subMenu: null,
	},
};

export const companyPageMenues = {
	com: {
		id: company,
		text: company,
		icon: "Extension",
	},
	company: {
		id: company,
		text: company,
		path: "company/details",
		icon: "HomeWork",
	},
	users: {
		id: "users",
		text: "users",
		path: "company/users",
		icon: "PersonAddAlt",
	},
};

export const saloonPageMenues = {
	com: {
		id: saloon,
		text: saloon,
		icon: "HomeWork",
		block: ["saloonDetail", "gates", "saloonGeneralInfo", "saloonGallery", "saloonCertificates", "gates", "places", "envantory", "cleaning"],
	},
	saloonDetail: {
		id: "saloonDetail",
		text: "saloonDetail",
		path: "saloon/detaıl",
		icon: "HomeWork",
		block: ["saloonGeneralInfo", "saloonGallery"],
		master: [saloon],
		subMenu: {
			saloonGeneralInfo: {
				id: "saloonGeneralInfo",
				text: "saloonGeneralInfo",
				path: "saloon/general-info",
				icon: "InfoOutline",
				master: [saloon, "saloonDetail"],
			},
			saloonGallery: {
				id: "saloonGallery",
				text: "saloonGallery",
				path: "saloon/gallery",
				icon: "AddPhotoAlternate",
				master: [saloon, "saloonDetail"],
			},
			saloonCertificates: {
				id: "saloonCertificates",
				text: "saloonCertificates",
				path: "saloon/certificates",
				icon: "Approval",
				master: [saloon, "saloonDetail"],
			},
		}
	},
	gates: {
		id: "gates",
		text: "gates",
		path: "saloon/gates-statistic",
		icon: "MultipleStop",
		master: [saloon],
		block: []
	},
	places: {
		id: "places",
		text: "places",
		path: "saloon/places",
		icon: "DoorFront",
		master: [saloon],
		block: []
	},
	// envantory: {
	// 	id: "envantory",
	// 	text: "envantory",
	// 	path: "saloon/envantory",
	// 	icon: "BackupTable",
	// 	master: [saloon],
	// 	block: []
	// },
	// cleaning: {
	// 	id: "cleaning",
	// 	text: "cleaning",
	// 	path: "saloon/cleaning",
	// 	icon: "CleaningServices",
	// 	master: [saloon],
	// 	block: []

	// },
};

export const webPageMenues = {
	webPages: {
		id: web,
		text: web,
		icon: "Extension",
		block: ["webPage", "subscriptions", "events", "blog"],
	},
	web: {
		id: "webPage",
		text: "webPage",
		path: "web/web",
		icon: "Web",
		block: ["subscriptions", "events", "blog"],
		master: [web],
		subMenu: {
			subscriptions: {
				id: "wsubscriptions",
				text: "wsubscriptions",
				path: "web/subscriptions",
				icon: "AttachMoney",
				master: [web, "webPage"],
			},
			events: {
				id: "events",
				text: "events",
				path: "web/events",
				icon: "Event",
				master: [web, "webPage"],
			},
			blog: {
				id: "blog",
				text: "blog",
				path: "web/blog",
				icon: "Article",
				master: [web, "webPage"],
			},
		}
	},
}

export const marketingPageMenues = {
	marketing: {
		id: marketing,
		text: marketing,
		icon: "Extension",
		block: ["marketingAudience", "forms", "calls", "visits", "marketingSales", "contactBase", "staffBase", "marketingStats", "contactBaseStats", "staffBaseStats"]
	},
	forms: {
		id: "forms",
		text: "forms",
		icon: "Badge",
		path: "/marketing/forms",
		master: [marketing, "marketingAudience"],
	},
	marketingSales: {
		id: "marketingSales",
		text: "marketingSales",
		icon: "CheckCircleOutline",
		path: "/marketing/stats",
		master: [marketing],
		block: ["contactBase", "staffBase"],
		subMenu: {
			contactBase: {
				id: "contactBase",
				text: "contactBase",
				icon: "People",
				path: "/marketing/contact-base",
				master: [marketing, "marketingSales"],
			},
			staffBase: {
				id: "staffBase",
				text: "staffBase",
				icon: "PersonPin",
				path: "/marketing/staff-base",
				master: [marketing, "marketingSales"],
			}
		}
	},
	marketingStats: {
		id: "marketingStats",
		text: "marketingStats",
		icon: "BarChart",
		path: "/marketing/stats",
		master: [marketing],
		block: ["contactBaseStats", "staffBaseStats"],
		subMenu: {
			contactBaseStats: {
				id: "contactBaseStats",
				text: "contactBaseStats",
				icon: "People",
				path: "/marketing/contact-base",
				master: [marketing, "marketingStats"],
			},
			staffBaseStats: {
				id: "staffBaseStats",
				text: "staffBaseStats",
				icon: "PersonPin",
				path: "/marketing/staff-base",
				master: [marketing, "marketingStats"],
			}
		}
	},
};

export const customerPageMenues = {
	customer: {
		id: customer,
		text: customer,
		icon: "Extension",
		block: ["messages", "subscriptions", "customers", "activeCustomers", "passiveCustomers", "customerWorkouts", "customerNutritions"],
	},
	messages: {
		id: "messages",
		text: "messages",
		icon: "Message",
		path: "/customer/messages",
		master: [customer],
		block: [],
	},
	subscriptions: {
		id: "subscriptions",
		text: "subscriptions",
		icon: "PermContactCalendar",
		path: "/customer/subscriptions",
		master: [customer],
		block: [],
	},
	customers: {
		id: "customers",
		text: "customers",
		icon: "PeopleAlt",
		path: "/customer/list",
		master: [customer],
		block: ["activeCustomers", "passiveCustomers", "customerWorkouts", "customerNutritions"],
		subMenu: {
			activeCustomers: {
				id: "activeCustomers",
				text: "activeCustomers",
				icon: "PersonAddAlt",
				path: "/customer/active-customers",
				master: [customer, "customers"],
			},
			customerWorkouts: {
				id: "customerWorkouts",
				text: "customerWorkouts",
				icon: "DirectionsRun",
				path: "/customer/workout-customers",
				master: [customer, "customers"],
			},
			customerNutritions: {
				id: "customerNutritions",
				text: "customerNutritions",
				icon: "Fastfood",
				path: "/customer/nutrition-customers",
				master: [customer, "customers"],
			},
			passiveCustomers: {
				id: "passiveCustomers",
				text: "passiveCustomers",
				icon: "PersonRemove",
				path: "/customer/passive-customers",
				master: [customer, "customers"],
			}
		}
	},

};

export const programMenues = {
	program: {
		id: program,
		text: program,
		icon: "Dashboard",
		subMenu: null,
		block: ["workout", "movements", "workouts", "food", "foods", "recipes", "nutrition", "sets", "nutritionPrograms"],
	},
	workout: {
		id: "workout",
		text: "workout",
		path: "page-layouts",
		icon: "PlaylistAddCheck",
		master: [program],
		block: ["movements", "workouts"],
		subMenu: {
			movements: {
				id: "movements",
				text: "movements",
				path: "programs/movements",
				icon: "DirectionsRun",
				master: [program, "workout"],
			},
			workouts: {
				id: "workouts",
				text: "workouts",
				path: "program/workouts",
				icon: "PlaylistAddCheck",
				master: [program, "workout"],
			},
		},
	},
	foods: {
		id: "food",
		text: "food",
		path: "page-layouts",
		icon: "FoodBank",
		master: [program],
		block: ["foods", "recipes"],
		subMenu: {
			foods: {
				id: "foods",
				text: "foods",
				path: "programs/foods",
				icon: "FoodBank",
				master: [program, "food"],
			},
			recipes: {
				id: "recipes",
				text: "recipes",
				path: "program/recipes",
				icon: "SetMeal",
				master: [program, "food"],
			},
		},
	},
	nutrition: {
		id: "nutrition",
		text: "nutrition",
		path: "page-layouts",
		icon: "DinnerDining",
		master: [program],
		block: ["sets", "nutritionPrograms"],
		subMenu: {
			sets: {
				id: "sets",
				text: "sets",
				path: "programs/nutrition-sets",
				icon: "TableView",
				master: [program, "nutrition"],
			},
			nutritionPrograms: {
				id: "nutritionPrograms",
				text: "nutritionPrograms",
				path: "program/nutrition-programs",
				icon: "PivotTableChart",
				master: [program, "nutrition"],
			},
		},
	},
};

export const calendarPageMenues = {
	company: {
		id: calendar,
		text: calendar,
		icon: "Dashboard",
		subMenu: null,
	},
	calendarSettings: {
		id: "calendarSettings",
		text: "calendarSettings",
		icon: "Settings",
		path: "/calendar/calendar-settings",
		master: [calendar],
		block: [],
	},
	calendarList: {
		id: "calendarList",
		text: "calendarList",
		icon: "EditCalendar",
		master: [calendar],
		block: ["sets", "nutritionPrograms"],
		path: "/calendar/reservations",
	}
};

export const financeReportPageMenues = {
	financeReport: {
		id: financeReport,
		text: financeReport,
		icon: "AttachMoney",
		block: ["accounts", "transactions", "accounts2", "monthlyBalance", "general", "income", "outcome"]
	},
	accounts: {
		id: "accounts",
		text: "accounts",
		icon: "AccountBalanceWallet",
		path: "/finance-report/stats",
		master: [financeReport],
		block: ["transactions", "accounts2"],
		subMenu: {
			transactions: {
				id: "transactions",
				text: "transactions",
				icon: "AttachMoney",
				path: "/finance-report/transactions",
				master: [financeReport, "accounts"],
			},
			accounts: {
				id: "accounts2",
				text: "accounts2",
				icon: "AccountBalanceWallet",
				path: "/finance-report/accounts",
				master: [financeReport, "accounts"],
			}
		}
	},
	monthlyBalance: {
		id: "monthlyBalance",
		text: "monthlyBalance",
		icon: "EditCalendar",
		path: "/finance-report/stats",
		master: [financeReport],
		block: ["general", "income", "outcome"],
		subMenu: {
			general: {
				id: "general",
				text: "general",
				icon: "Analytics",
				path: "/finance-report/general",
				master: [financeReport, "monthlyBalance"],
			},
			income: {
				id: "income",
				text: "income",
				icon: "ArrowCircleDown",
				path: "/finance-report/income",
				master: [financeReport, "monthlyBalance"],
			},
			outcome: {
				id: "outcome",
				text: "outcome",
				icon: "ArrowCircleUp",
				path: "/finance-report/outcome",
				master: [financeReport, "monthlyBalance"],
			},
		}
	},
};

export const myPages = {
	department: {
		id: "departman",
		text: "department",
		path: "/dashboard/departments",
		icon: "Dashboard",
		isPublic: true
	},
	projects: {
		id: "proje",
		text: "projects",
		path: "/dashboard/projects",
		icon: "Workspaces",
		isPublic: true
	},
	production: {
		id: "production",
		text: "production",
		path: "/dashboard/production",
		icon: "Verified",
		isPublic: true
	},
	tasks: {
		id: "tasks",
		text: "tasks",
		path: "/dashboard/tasks",
		icon: "Task",
		isPublic: true
	},
};

export const demoPagesMenu = {
	auth: {
		id: "auth",
		text: "Auth Pages",
		icon: "Extension",
	},
	login: {
		id: "login",
		text: "login",
		path: "auth/login",
		icon: "Login",
	},
	signUp: {
		id: "signUp",
		text: "signUp",
		path: "auth/sign-up",
		icon: "PersonAdd",
	},
	page404: {
		id: "Page404",
		text: "404",
		path: "auth/404",
		icon: "ReportGmailerrorred",
	},
};

export const pageLayoutTypesPagesMenu = {
	layoutTypes: {
		id: "layoutTypes",
		text: "Page Layout Types",
	},
	blank: {
		id: "blank",
		text: "Blank",
		path: "page-layouts/blank",
		icon: "check_box_outline_blank ",
	},
	pageLayout: {
		id: "pageLayout",
		text: "Page Layout",
		path: "page-layouts",
		icon: "BackupTable",
		subMenu: {
			headerAndSubheader: {
				id: "headerAndSubheader",
				text: "Header & Subheader",
				path: "page-layouts/header-and-subheader",
				icon: "ViewAgenda",
			},
			onlyHeader: {
				id: "onlyHeader",
				text: "Only Header",
				path: "page-layouts/only-header",
				icon: "ViewStream",
			},
			onlySubheader: {
				id: "onlySubheader",
				text: "Only Subheader",
				path: "page-layouts/only-subheader",
				icon: "ViewStream",
			},
			onlyContent: {
				id: "onlyContent",
				text: "Only Content",
				path: "page-layouts/only-content",
				icon: "WebAsset",
			},
		},
	},
	asideTypes: {
		id: "asideTypes",
		text: "Aside Types",
		path: "aside-types",
		icon: "Vertical Split",
		subMenu: {
			defaultAside: {
				id: "defaultAside",
				text: "Default Aside",
				path: "aside-types/default-aside",
				icon: "ViewQuilt",
			},
			minimizeAside: {
				id: "minimizeAside",
				text: "Minimize Aside",
				path: "aside-types/minimize-aside",
				icon: "View Compact",
			},
		},
	},
};

export const summaryPageTopMenu = {
	intro: { id: "intro", text: "Intro", path: "#intro", icon: "Vrpano", subMenu: null },
	bootstrap: {
		id: "bootstrap",
		text: "Bootstrap Components",
		path: "#bootstrap",
		icon: "BootstrapFill",
		subMenu: null,
	},
	storybook: {
		id: "storybook",
		text: "Storybook",
		path: "#storybook",
		icon: "CustomStorybook",
		subMenu: null,
	},
	formik: {
		id: "formik",
		text: "Formik",
		path: "#formik",
		icon: "CheckBox",
		subMenu: null,
	},
	apex: {
		id: "apex",
		text: "Apex Charts",
		path: "#apex",
		icon: "AreaChart",
		subMenu: null,
	},
};

export const productsExampleMenu = {
	companyA: { id: "companyA", text: "Company A", path: "grid-pages/products", subMenu: null },
	companyB: { id: "companyB", text: "Company B", path: "/", subMenu: null },
	companyC: { id: "companyC", text: "Company C", path: "/", subMenu: null },
	companyD: { id: "companyD", text: "Company D", path: "/", subMenu: null },
};
